import React from "react";
import { StyleSheet, View } from "react-native";
import ProjectCard from "../ProjectCard/ProjectCard";

import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import Loader from "../../common/status/Loader/Loader";

const ProjectCardList = ({ journeys, onJourneyPress, journeysLoading }) => {
  if (journeysLoading) {
    return (
      <>
        <CustomSpacing type="vertical" />
        <Loader />
        <CustomSpacing type="vertical" />
      </>
    );
  }

  return (
    <View>
      <View style={styles.container}>
        {journeys?.map((card) => (
          <ProjectCard key={card.id} card={card} onJourneyPress={onJourneyPress} />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-start",
  },
});

export default ProjectCardList;
